import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios";
import ModalCampaignModal from "./ModalCampaignModal";

const ENDPOINT = "/notifications/modal-campaign/";

export default function ModalCampaignController({ userId, language, blocked = false, onPriorityChange }) {
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const recordedSlugRef = useRef(null);
  const open = Boolean(userId && loaded && campaign && !blocked);

  useEffect(() => {
    setCampaign(null);
    setLoaded(false);
    recordedSlugRef.current = null;
    if (!userId) return undefined;

    let cancelled = false;
    api.get(ENDPOINT, { meta: { suppressGlobalError: true } })
      .then(({ data }) => {
        if (!cancelled) setCampaign(data?.campaign || null);
      })
      .catch((error) => {
        console.warn("[ModalCampaign] failed to load campaign", error);
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => { cancelled = true; };
  }, [userId]);

  useEffect(() => {
    onPriorityChange?.(Boolean(userId && (!loaded || campaign)));
  }, [campaign, loaded, onPriorityChange, userId]);

  useEffect(() => {
    if (!open || recordedSlugRef.current === campaign.slug) return;
    recordedSlugRef.current = campaign.slug;
    void api.post(
      `${ENDPOINT}${encodeURIComponent(campaign.slug)}/impression/`,
      { action: "shown" },
      { meta: { suppressGlobalError: true } }
    ).catch((error) => {
      console.warn("[ModalCampaign] failed to record display", error);
    });
  }, [campaign, open]);

  const close = () => {
    setCampaign(null);
    onPriorityChange?.(false);
  };

  const visit = () => {
    const path = campaign?.destination_path;
    if (!path || !path.startsWith("/") || path.startsWith("//")) return;
    void api.post(
      `${ENDPOINT}${encodeURIComponent(campaign.slug)}/impression/`,
      { action: "clicked" },
      { meta: { suppressGlobalError: true } }
    ).catch((error) => {
      console.warn("[ModalCampaign] failed to record event visit", error);
    });
    close();
    navigate(path);
  };

  return (
    <ModalCampaignModal
      campaign={campaign}
      open={open}
      onClose={close}
      onAction={visit}
      language={language}
    />
  );
}
